import { motion } from "framer-motion";
import { Leaf, MapPin, Wind } from "lucide-react";

const MATTRESS_IMG =
  "https://images.unsplash.com/photo-1762199904077-1c83cebbd205?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHw0fHxtYXR0cmVzcyUyMGNsZWFuaW5nJTIwY2xlYW4lMjBiZWRyb29tJTIwbWF0dHJlc3N8ZW58MHx8fHwxNzkxNzE3MjIyfDA&ixlib=rb-4.1.0&q=85";

const stats = [
  { icon: MapPin, value: "100%", label: "interventions à domicile" },
  { icon: Wind, value: "2h – 4h", label: "de séchage seulement" },
  { icon: Leaf, value: "100%", label: "produits éco-responsables" },
];

export default function Atelier() {
  return (
    <section className="py-20 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 items-center gap-14 lg:grid-cols-12">
          <motion.div
            initial={{ opacity: 0, x: -32 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8 }}
            className="lg:col-span-5"
          >
            <div className="overflow-hidden rounded-[2.5rem] rounded-bl-[6rem] shadow-2xl shadow-slate-900/15">
              <img
                src={MATTRESS_IMG}
                alt="Matelas impeccable après nettoyage et assainissement professionnel"
                className="h-[24rem] w-full object-cover sm:h-[28rem]"
              />
            </div>
          </motion.div>

          <div className="lg:col-span-7">
            <motion.div
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7 }}
            >
              <p className="mb-4 text-xs font-semibold uppercase tracking-[0.25em] text-teal-700 sm:text-sm">
                Pourquoi PureTextiles
              </p>
              <h2 className="font-serif text-3xl font-medium tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
                Le propre en profondeur, sans quitter votre salon
              </h2>
              <p className="mt-5 max-w-xl text-base leading-relaxed text-slate-600 sm:text-lg">
                Matériel professionnel d'injection-extraction, produits
                respectueux des fibres et de votre intérieur, et un soin du
                détail sur chaque intervention.
              </p>
            </motion.div>

            <div data-testid="atelier-stats" className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-3">
              {stats.map((s, i) => (
                <motion.div
                  key={s.label}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.1 }}
                  className="rounded-3xl border border-slate-200 bg-white p-6 text-center shadow-sm"
                >
                  <s.icon className="mx-auto h-6 w-6 text-teal-600" />
                  <p className="mt-3 font-serif text-4xl font-semibold text-slate-900">{s.value}</p>
                  <p className="mt-1 text-sm text-slate-500">{s.label}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
